var _path, _path2, _defs, _circle, _path3, _circle2, _path4, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMember = function SvgMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "member_svg__st0",
    d: "M12 24C5.38 24 0 18.62 0 12S5.38 0 12 0s12 5.38 12 12-5.38 12-12 12zm0-22.08C6.44 1.92 1.92 6.44 1.92 12S6.44 22.08 12 22.08 22.08 17.56 22.08 12 17.56 1.92 12 1.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "member_svg__st0",
    d: "M12 1.44c5.82 0 10.56 4.74 10.56 10.56S17.82 22.56 12 22.56 1.44 17.82 1.44 12 6.18 1.44 12 1.44m0-.96C5.64.48.48 5.64.48 12S5.64 23.52 12 23.52 23.52 18.36 23.52 12 18.37.48 12 .48z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "member_svg__a",
    cx: 12,
    cy: 12,
    r: 9.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "member_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#member_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#member_svg__b)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "member_svg__st0",
    cx: 8.44,
    cy: 9.32,
    r: 3.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "member_svg__st0",
    d: "M8.17 13.41c-3.11 0-5.73 2.03-6.64 4.83.77.89 1.71 1.62 2.77 2.15h.08c1.15.55 2.43.87 3.78.87 1.36 0 2.64-.32 3.78-.87h.09a8.839 8.839 0 0 0 2.77-2.15 6.96 6.96 0 0 0-6.63-4.83z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "member_svg__st0",
    cx: 16,
    cy: 7.93,
    r: 2.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "member_svg__st0",
    d: "M14.98 19.16c0 2.63-2.3 4.76-4.93 4.76s-4.76-2.13-4.76-4.76 1.52-5.93 4.13-5.63c2.47.28 5.56 3 5.56 5.63z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "member_svg__c",
    cx: 12,
    cy: 12,
    r: 9.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "member_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#member_svg__c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#member_svg__d)"
    },
    d: "M21.38 14.89c-.96-2.02-3-3.43-5.38-3.43-1.72 0-3.26.73-4.35 1.9 1.86.92 3.32 2.55 3.99 4.63.02.06.03.12.03.19.01.06.48 2.11-.49 3.21l-.36 2.43 6.5-.04.96-7.5-.9-1.39z"
  }));
};
export default SvgMember;